import React from 'react';
import { useLocation } from 'react-router';

import type { IStyle } from 'fela';

import NavButton from './NavButton';

interface BackButtonProps {
  // Where to go when there is no in-app history to return to, e.g. when the
  // page was opened straight from a shared link.
  fallbackTo: string;
  style?: IStyle;
  children?: React.ReactNode;
}

export const BackButton: React.FC<BackButtonProps> = ({ children, fallbackTo, style }) => {
  const location = useLocation();

  // react-router gives the first entry of a session the key "default", so any
  // other key means the user navigated here from another page in the app.
  const hasHistory = location.key !== 'default';

  return (
    <NavButton to={hasHistory ? -1 : fallbackTo} className="kb-back-button" style={{ marginBottom: '24px', ...style }}>
      {children}
    </NavButton>
  );
};

export default BackButton;
